import { Permission, SecurityScope } from '../../../../../auth/auth.model';
import { AuthService } from '../../../../../auth/auth.service';
import { epicDependencies } from '../../../../../store';
import { AllowedActions } from '../model/allowed-actions.model';

export function determineAllowedActions(): AllowedActions {
    const service = epicDependencies.injector.get<AuthService>(AuthService); // TODO FIXME revise

    const canDeleteTranscript = service.user.hasPermission(
        Permission.TEAMS_CALL_DELETE_TRANSCRIPT,
        SecurityScope.COACHING,
    );

    const canImportTranscript = service.user.hasPermission(
        Permission.TEAMS_CALL_IMPORT_TRANSCRIPT,
        SecurityScope.COACHING,
    );

    return {
        deleteTranscript: canDeleteTranscript,
        importTranscript: canImportTranscript,
    };
}
